












import Vue from 'vue';
import Component from 'vue-class-component';
import NavBar from '@components/NavBar.vue';
import NavBarDrawer from '@components/NavBarDrawer.vue';

@Component({
    components: { NavBar, NavBarDrawer },
})
export default class FocusedLayout extends Vue {}
